/**
 * Agenda callback após idle ou timeout mínimo (fallback para browsers sem requestIdleCallback).
 */
export const agendarIdle = (fCallback, nTimeoutFallbackMs = 100) => {
  if (typeof requestIdleCallback !== "undefined") {
    return requestIdleCallback(fCallback, { timeout: nTimeoutFallbackMs * 10 })
  }
  return setTimeout(fCallback, nTimeoutFallbackMs)
}

export const cancelarAgendamentoIdle = (nIdAgendamento) => {
  if (typeof cancelIdleCallback !== "undefined" && typeof nIdAgendamento === "number") {
    cancelIdleCallback(nIdAgendamento)
    return
  }
  clearTimeout(nIdAgendamento)
}
